module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Black-Italic.4017af98.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Black-Italic.ttf
// module id = 2330
// module chunks = 50